const Order = {
    orders: 'Orders',
    order_details: 'Order Details',
    order_number: 'Order Number',
    customer: 'Customer',
    email: 'Email',
    mobile: 'Mobile',
    search: 'Search',
    select_status: 'Select status',
    order_status: 'Order Status',
    payment_status: 'Payment Status',
    view_order: 'View Order',
    change_status: 'Change Order Status',
    generate_invoice: 'Generate Invoice',
    invoice_unavailable: 'Unable to generate invoice',
    error_order_status: 'Order status is required',
    status_updated: 'Order status updated successfully',
    details_error: 'Unable to load order details',

    table_order_number: 'ORDER NUMBER',
    table_customer: 'CUSTOMER',
    table_items: 'ITEMS',
    table_total: 'TOTAL',
    table_order_status: 'ORDER STATUS',
    table_payment_status: 'PAYMENT STATUS',
    table_placed_on: 'PLACED ON',

    customer_information: 'Customer Information',
    pincode: 'Pincode',
    payment_method: 'Payment Method',
    estimated_delivery: 'Estimated Delivery',
    days: 'days',
    placed_on: 'Placed on',
    paid_at: 'Paid at',
    remarks: 'Remarks',
    customer_remarks: 'Customer Remarks',
    amount_summary: 'Amount Summary',
    subtotal: 'Subtotal',
    discount: 'Discount',
    gst: 'GST',
    shipping_fee: 'Shipping Fee',
    grand_total: 'Grand Total',
    items: 'Order Items',
    product: 'Product',
    sku: 'SKU',
    variant: 'Variant',
    quantity: 'Quantity',
    price: 'Price',
    total: 'Total',
    stock_status: 'Stock Status',
    no_items: 'No order items available',
    addresses: 'Order Addresses',
    address: 'Address',
    no_addresses: 'No addresses available',
    payments: 'Payments',
    no_payments: 'No payment records available',
    internal_remarks: 'Internal Remarks',
    reason: 'Reason',
    status_history: 'Status History',
    no_history: 'No status history available',
}

export default Order;